import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class Ventas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Ventas', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('select', 'type', 'Tipo', '', [Validators.required], 6, [
          { Label: 'Global', Value: '1' },
          { Label: 'Detallado', Value: '2' },
        ]),
      ], ['Descargar Excel'], 'Ventas x Concepto'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`reporte/ventas-concepto?q=1&start_date=${start}&end_date=${end}`, true, 'arraybuffer')
    if (Resp) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a');
      link.href = url;
      link.download = 'recorte.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender on />
      </div>
    )
  }
}

export default withRouter(Ventas)
